import { getReceivedAddressListApi, getAddressSourceApi, addAddressApi, EditReceivedDetailApi, deleteAddressAPi } from '@/api/address'
import { Toast } from 'vant'
export default {
  // 开启命名空间
  namespaced: true,
  state () {
    return {
      // 获取到的全国省市区信息
      regionData: {},
      // 收货地址列表
      receiveAddressList: []
    }
  },
  mutations: {
    // 设置收货地址列表
    setReceivedAddressList (state, obj) {
      state.receiveAddressList = obj
    },
    // 设置全国省市区地址
    NationalAddressList (state, list) {
      state.regionData = list
    }
  },
  actions: {
    // 获取收货地址列表
    async getReceivedAddressList (context) {
      const res = await getReceivedAddressListApi()
      // console.log(res.data.list)
      context.commit('setReceivedAddressList', res.data.list)
    },
    // 获取省市区信息
    async getAddressSource (context) {
      const res = await getAddressSourceApi()

      context.commit('NationalAddressList', res.data.list)
    },
    // 添加地址
    async addAddress (context, obj) {
      await addAddressApi(obj)
      Toast('添加成功')
      // 然后再调用下getReceivedAddressList，重新同步下本地收货地址列表信息
      context.dispatch('getReceivedAddressList')
    },
    // 编辑地址
    async EditAddress (context, { addressId, obj }) {
      await EditReceivedDetailApi(addressId, obj)
      Toast('删除成功')
      // 然后再调用下getReceivedAddressList，重新同步下本地收货地址列表信息
      context.dispatch('getReceivedAddressList')
    },
    // 删除地址
    async deleteAddress (context, addressId) {
      await deleteAddressAPi(addressId)
      Toast('删除成功')
      context.dispatch('getReceivedAddressList')
    }
  },
  getters: {
    // 将获取到的省市区数据进行加工，使其vant组件 'Cascader 级联选择' 可以使用
    nationlAddressList (state) {
      const obj = []
      const res = state.regionData
      let key1 = 1
      let key2 = 1
      let key3 = 1
      for (key1 in res) {
        const element = {}
        if (res[key1].name) {
          element.text = res[key1].name
          element.value = res[key1].id
        }
        if (res[key1].city) {
          element.children = []
          for (key2 in res[key1].city) {
            element.children.push({
              text: res[key1].city[key2].name,
              value: res[key1].city[key2].id
            })
            if (res[key1].city[key2].region) {
              const length = element.children.length - 1
              element.children[length].children = []
              for (key3 in res[key1].city[key2].region) {
                element.children[length].children.push({
                  text: res[key1].city[key2].region[key3].name,
                  value: res[key1].city[key2].region[key3].id
                })
              }
            }
          }
        }
        obj.push(element)
      }
      // console.log(obj)
      return obj
    },
    // 收货地址列表
    receivedAddress (state) {
      return state.receiveAddressList
    }

  }
}
